import {
  GenerateAgenticLogicRuleGraphMemberRequestType,
  GenerateAgenticLogicRuleGraphResponseType,
} from "@intelligems/ig-types/functions/agentic-logic/generate-graph/generate-graph";
import { aiApiClient } from "@src/api/ai-api";
import { useMutation } from "@tanstack/react-query";

/**
 * Direct call to the ai service's member generation route — the interactive
 * lane. Generation takes up to a couple of minutes; the ai service sits
 * behind its own ALB, not API Gateway, so a long synchronous call is fine.
 * The caller persists the result through save-draft, which runs the
 * code≡graph consistency check.
 */
const generateAgenticLogicGraph = async (
  body: GenerateAgenticLogicRuleGraphMemberRequestType
) => {
  const resp =
    await aiApiClient.post<GenerateAgenticLogicRuleGraphResponseType>(
      "/agentic-logic-graph/generate-for-rule",
      body,
      { timeout: 180_000 }
    );
  return resp.data;
};

export const useGenerateAgenticLogicGraph = () => {
  return useMutation<
    GenerateAgenticLogicRuleGraphResponseType,
    Error,
    GenerateAgenticLogicRuleGraphMemberRequestType
  >({ mutationFn: generateAgenticLogicGraph });
};
